import { fitSelect2DropdownToViewport } from './floating-dropdown-position.js';

let initialized = false;
let enforceFocusPatched = false;

function isSelect2FocusTarget(target) {
    if (!target || target === document) {
        return false;
    }
    return Boolean(
        $(target).closest('.select2-container, .select2-dropdown, .select2-search, .select2-results').length
    );
}

export function patchBootstrapModalSelect2Focus() {
    if (enforceFocusPatched) {
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$ || !$.fn || !$.fn.modal) {
        return;
    }

    const Modal = $.fn.modal.Constructor;
    if (!Modal || typeof Modal.prototype._enforceFocus !== 'function') {
        return;
    }

    enforceFocusPatched = true;
    const EVENT_FOCUSIN = 'focusin.bs.modal';

    Modal.prototype._enforceFocus = function () {
        const element = this._element;
        $(document).off(EVENT_FOCUSIN).on(EVENT_FOCUSIN, function (e) {
            const target = e.target;
            if (target === document || target === element) {
                return;
            }
            if ($(element).has(target).length > 0) {
                return;
            }
            if (isSelect2FocusTarget(target)) {
                return;
            }
            element.focus();
        });
    };
}

export function initSelect2DocumentHandlers() {
    if (initialized) {
        return;
    }
    initialized = true;

    patchBootstrapModalSelect2Focus();

    $(document).on('mousedown.select2AllowFocus click.select2Container', '.select2-container, .select2-dropdown', function (e) {
        e.stopPropagation();
    });

    $(document).on('select2:open.select2ViewportFitGlobal', function (event) {
        const selectEl = event.target;
        requestAnimationFrame(function () {
            fitSelect2DropdownToViewport(selectEl);
            requestAnimationFrame(function () {
                fitSelect2DropdownToViewport(selectEl);
            });
        });
    });

    window.addEventListener('error', function (e) {
        if (e.message && e.message.includes('Extension context invalidated')) {
            e.preventDefault();
            return false;
        }
    });
}
